import api from "./api"

export type SessionStatus = "IN_PROGRESS" | "COMPLETED"
export type ItemResult = "UYGUN" | "UYGUNSUZ" | "NA"

export interface ElevatorChecklistSession {
  id: string
  elevatorProjectId: string
  checklistId: string
  userId: string
  status: SessionStatus
  startedAt: string
  completedAt: string | null
  createdAt: string
  updatedAt: string
  checklist?: { id: string; code: string; description: string | null }
}

export interface ItemResponse {
  id: string
  result: ItemResult
  notes: string | null
  sessionId: string
  checklistItemId: string
  nonConformities: { id: string; text: string }[]
  measurements: { id: string; value: string; dataRecordField: { code: string; name: string; unit: string | null } }[]
  photos: { id: string; fileId: string; file: { id: string; filename: string; mimeType: string } }[]
  createdAt: string
  updatedAt: string
}

export interface SessionDetail extends ElevatorChecklistSession {
  responses: ItemResponse[]
}

export interface PaginatedSessions {
  data: ElevatorChecklistSession[]
  total: number
  totalPages: number
  page: number
  pageSize: number
}

export interface CreateSessionPayload {
  checklistId: string
}

export interface MeasurementInput {
  dataRecordFieldId: string
  value: string
}

export interface UpsertResponsePayload {
  checklistItemId: string
  result: ItemResult
  notes?: string
  nonConformities?: string[]
  measurements?: MeasurementInput[]
  photoFileIds?: string[]
}

export async function fetchProjectSessions(projectId: string, params: { page?: number; pageSize?: number } = {}) {
  const { data } = await api.get<PaginatedSessions>(`/elevator-projects/${projectId}/checklist-entries`, { params })
  return data
}

export async function fetchSessionDetail(projectId: string, sessionId: string) {
  const { data } = await api.get<SessionDetail>(`/elevator-projects/${projectId}/checklist-entries/${sessionId}`)
  return data
}

export async function createSession(projectId: string, payload: CreateSessionPayload) {
  const { data } = await api.post<ElevatorChecklistSession>(`/elevator-projects/${projectId}/checklist-entries`, payload)
  return data
}

export async function upsertResponse(projectId: string, sessionId: string, payload: UpsertResponsePayload) {
  const { data } = await api.post<ItemResponse>(`/elevator-projects/${projectId}/checklist-entries/${sessionId}/responses`, payload)
  return data
}

export async function completeSession(projectId: string, sessionId: string) {
  const { data } = await api.post<ElevatorChecklistSession>(`/elevator-projects/${projectId}/checklist-entries/${sessionId}/complete`, {})
  return data
}

/** Maddenin yanıtını siler — sonuç işareti kaldırıldığında. */
export async function deleteResponse(projectId: string, sessionId: string, checklistItemId: string) {
  await api.delete(`/elevator-projects/${projectId}/checklist-entries/${sessionId}/responses/${checklistItemId}`)
}
